import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const ViewCheckOutModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 p-2 flex items-center justify-center backdrop-blur-sm bg-black/50 bg-opacity-50">
      <div className="bg-white w-full h-[30rem] lg:h-fit overflow-y-auto lg:max-w-3xl p-6 rounded-lg shadow-lg relative">
        {/* Close Button */}
        <AiFillCloseCircle
          onClick={onClose}
          className="cursor-pointer text-primaryColor absolute top-4 right-4"
          size={30}
        />

        {/* Modal Title */}
        <h2 className="text-lg font-bold text-primaryTextColor mb-6 text-center">
          Booking Details
        </h2>

        {/* Content */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">Name:</span>
            <span className="text-sm text-primaryTextColor">
              {data?.name || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">Mobile:</span>
            <span className="text-sm text-primaryTextColor">
              {data?.mobile || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">Email:</span>
            <span className="text-sm text-primaryTextColor">
              {data?.email || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Room Number:
            </span>
            <span className="text-sm text-primaryTextColor">
              R-F{data.roomId.floorNumber}
              {String(data.roomId.roomNumber).padStart(3, "0")}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Bed Number:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.bedId?.bedNumber || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Hostel Name:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.hostelName?.nameBuilding || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Booking Amount:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.bookingAmount || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Security Deposit:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.securityDeposit || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Joining Date:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.joiningDate?.slice(0, 10) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Check-Out Date:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.checkOutDate?.slice(0, 10) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col md:col-span-2">
            <span className="font-semibold text-sm text-gray-400">
              Reason of Notice:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.notice?.UnderNotice
                ? data?.notice?.reasonOfNotice || "N/A"
                : "N/A"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCheckOutModal;
